import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
//import { Auth } from "../../../../../api";
import { initialValuesTwo, validationSchemaTwo } from "./PartnerFormTwo.form";
import { toast, ToastContainer } from "react-toastify";
import { countryOptions } from "../../../../Utils/countries";

//const authController = new Auth();

export function PartnerFormTwo(props) {
  const { formData,updateFormData,prevStep, nextStep} = props;
 
  const formik = useFormik({
    initialValues: initialValuesTwo( formData),
    validationSchema: validationSchemaTwo(),
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        updateFormData(values);
        nextStep(); // Avanza al siguiente paso
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: "top-center",
          autoClose: false, // Para que el usuario tenga que cerrarlo manualmente
          closeOnClick: true,
        });
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <Form onSubmit={formik.handleSubmit}>
        
        
      <Form.Input
          type="text"
          name="billAddress.address"
          placeholder="Dirección"
          onChange={formik.handleChange}
          value={formik.values.billAddress.address}
          error={
            formik.errors.billAddress?.address
              ? {
                  content: formik.errors.billAddress.address,
                  pointing: "above",
                }
              : null
          }
        />
        <Form.Input
          type="text"
          name="billAddress.city"
          placeholder="Ciudad"
          onChange={formik.handleChange}
          value={formik.values.billAddress.city}
          error={
            formik.errors.billAddress?.city
              ? { content: formik.errors.billAddress.city, pointing: "above" }
              : null
          }
        />
        <Form.Input
          type="text"
          name="billAddress.postalCode"
          placeholder="Código Postal"
          onChange={formik.handleChange}
          value={formik.values.billAddress.postalCode}
          error={
            formik.errors.billAddress?.postalCode
              ? {
                  content: formik.errors.billAddress.postalCode,
                  pointing: "above",
                }
              : null
          }
        />
        <Form.Input
          type="text"
          name="billAddress.province"
          placeholder="Provincia"
          onChange={formik.handleChange}
          value={formik.values.billAddress.province}
          error={
            formik.errors.billAddress?.province
              ? {
                  content: formik.errors.billAddress.province,
                  pointing: "above",
                }
              : null
          }
        />
        
        
        <Form.Select
          placeholder="Selecciona país"
          fluid
          selection
          options={countryOptions}
          name="billAddress.country"
          value={formik.values.billAddress.country}
          onChange={(_, { value }) =>
            formik.setFieldValue("billAddress.country", value)
          }
          error={
            formik.errors.billAddress?.country
              ? {
                  content: formik.errors.billAddress.country,
                  pointing: "above",
                }
              : null
          }
        />
        <Form.Input
          type="text"
          name="iban"
          placeholder="Iban Bancario"
          onChange={formik.handleChange}
          value={formik.values.iban}
          error={
            formik.errors.iban
              ? {
                  content: formik.errors.iban,
                  pointing: "above",
                }
              : null
          }
        />
        <Form.Input
          type="text"
          name="swift"
          placeholder="Swift"
          onChange={formik.handleChange}
          value={formik.values.swift}
          error={
            formik.errors.swift
              ? {
                  content: formik.errors.swift,
                  pointing: "above",
                }
              : null
          }
        />
        <div className="formgroup">
          <Form.Group>
            <Button
              type="button"
              onClick={prevStep}
              color="orange"
              style={{ width: "33.3333%" }}
            >
              Anterior
            </Button>
            <Button
              type="submit"
              primary
              style={{
                width: "33.3333%",
              }}
              loading={formik.isSubmitting}
            >
              Siguiente
            </Button>
          </Form.Group>
        </div>
      </Form>
    </>
  );
}
